module.exports = __webpack_public_path__ + "static/2_3_game-tree-4_PL-953296bf3a990a46b254f735ce6e981c.svg";